import { z } from 'zod';

const editServiceRateSchema = z.object({
    code: z.string(),
    rate: z.string(),
});

// One shared message covers every blank field — the per-field issue only marks the
// field invalid; nothing renders its own message text.
const MISSING_RATE_MESSAGE = '1 or more services is missing a rate';

export const editServiceRatesFormSchema = z
    .object({
        rates: z.array(editServiceRateSchema),
    })
    .superRefine((value, ctx) => {
        value.rates.forEach((entry, index) => {
            if (entry.rate.trim() === '') {
                ctx.addIssue({
                    code: 'custom',
                    message: MISSING_RATE_MESSAGE,
                    path: ['rates', index, 'rate'],
                });
            }
        });
    });

export type EditServiceRatesFormValues = z.input<typeof editServiceRatesFormSchema>;
